import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from 'vue';
import { useBiScroll } from '@/helpers/composables/useBiScroll';
import type { createLoadMoreEvent } from '@/helpers/composables/useBiScroll';

import PaginationNav from '@/components/nav/PaginationNav.vue';

interface InfiniteBiScrollProps {
	enabled: boolean;
	loading: boolean;
	pageSize: number;
	hardPageLimit?: number;
	titlesAmount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfiniteBiScroll',
  props: {
    enabled: { type: Boolean },
    loading: { type: Boolean },
    pageSize: null,
    hardPageLimit: { default: 4 },
    titlesAmount: { default: 0 }
  },
  emits: ["load-next", "load-prev"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'load-next' | 'load-prev', payload: { event: ReturnType<typeof createLoadMoreEvent>; page: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { enabled: boolean, loading: boolean, pageSize: number, hardPageLimit: number, titlesAmount: number }



const el = ref<HTMLElement | null>(null);
// emits an event with payload to stay compatible with <CustomIonInfiniteScroll>
// that uses event.target?.complete() after loadMore() events.

const onEmit = (eventName: 'load-next' | 'load-prev', payload: any) => {
	emit(eventName as any, payload);
};

function pageNumber(pageStart: number, index: number, titlesPerPage: number) {
	return Math.floor(pageStart - 1 + (index / titlesPerPage + 1));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { page, pageStart, lastPage, loadingPrev, loadingNext, anyLoading, ANCHOR_NAME } = useBiScroll(
	el,
	toRefs(props),
	onEmit
);

return { __sfc: true,props, el, emit, onEmit, pageNumber, page, pageStart, lastPage, loadingPrev, loadingNext, anyLoading, ANCHOR_NAME, PaginationNav }
}

})